import React from 'react';
var css = {
  "pageDots": "rui-Qu9PO",
  "dots": "rui-sfFlb"
};
var PageDots = function PageDots(_ref) {
  var _ref$dataAutId = _ref['data-aut-id'],
    dataAutId = _ref$dataAutId === void 0 ? 'pageDots' : _ref$dataAutId;
  return /*#__PURE__*/React.createElement("div", {
    className: css.pageDots,
    "data-aut-id": dataAutId
  }, /*#__PURE__*/React.createElement("span", {
    className: css.dots
  }, "..."));
};
export default PageDots;